// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate

export const review = {
  review_section: {
    contentful_name: 'Review Section (DEFAULT DO NOT CHANGE)',
    page_title: '审核并注册',
    page_header: {
      text: '查看您的福利',
      subtext: '让我们一起回顾您所选择的内容以及如何注册。',
    },
    info_bar: {
      FBS: '太好了,您已选择了补充计划!',
      noFBS: '太好了,您已选择了医疗保健计划!',
      noHealth: '您已选择不参加健康计划。',
    },
    pdf_link:
      'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
    button_text: {
      PDF: '保存为PDF/打印',
      change: '更改',
      enroll: '开始注册',
      PDFLink: '更多信息',
      warning: '跳转到注册',
      comments: '提交',
      nextSteps: '注册福利',
    },
    toggle_sections: ['1. 查看计划,2. 开始注册'],
    review_instructions: '让我们来回顾一下!以下是您所选计划的汇总情况。',
    enroll_warning: {
      text: '查看完您的计划后,请在下方了解您的注册选项。',
      header: '立即注册!',
    },
    enrollment_title: '准备好注册了吗?',
    enroll_instructions: '此链接将在新窗口中打开。',
    non_premium_benefits: '以下是您的所有福利,不含任何固定保费或缴费金额。',
    your_contribution_text: {
      saved: '您已保存的供款金额',
      notSaved: '您的推荐供款金额',
    },
    hsa_contributions: '包括健康储蓄账户供款吗?',
    enroll_heading: '注册时间',
    enrollment_completion_text: {
      complete: '完成!',
      incomplete: '完成?',
    },
    confirmation: '一切看起来都不错?让我们开始为您注册这些计划吧。',
    pdf_instructions: '保存为PDF或打印这些结果以供将来使用。',
    next_steps_header: '下一步',
    next_step_instructions: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '既然您已经决定要注册什么项目,现在是时候进行登记了。请访问您的登记平台以完成福利登记!',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
    next_step_fields: {
      email: '电子邮箱:',
      phone: '电话:',
      password: '密码:',
      username: '用户名:',
    },
    show_enrollment_text: false,
    phone_heading:
      'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
    email_heading:
      'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
    website_heading:
      'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation for you.',
    experience_heading: '我们很想知道!',
    experience_question: '您使用此工具的整体体验如何?',
    response_heading: '感谢您的回复!',
    response_body: '我们非常感谢您的反馈,这将有助于改善体验!',
    comment_instructions: '如有任何意见,请在下方填写。',
    comment_placeholder_text: '在此添加评论或反馈...',
    ratings: {
      '1': {
        alt: '撅嘴脸',
        icon: '😡',
        text: '糟糕',
      },
      '2': {
        alt: '微皱眉脸',
        icon: '🙁',
        text: '不好',
      },
      '3': {
        alt: '中性脸',
        icon: '😐',
        text: '还行',
      },
      '4': {
        alt: '眯眼微笑脸',
        icon: '😊',
        text: '好',
      },
      '5': {
        alt: '大眼咧嘴笑脸',
        icon: '😃',
        text: '很好',
      },
    },
    username_hint:
      'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
    password_hint:
      'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
    more_info_heading: '如需了解更多关于开放注册的信息,请查看人力资源部门提供的PDF文件。',
    accessibility: {
      rating_submitted_alert: '评分已提交',
      comments_submitted_alert: '评论已提交',
    },
    lets_enroll_card_text: '嘿,你做到了!你已经决定要注册什么了,但还需要完成报名!',
    learn_more_text: '在您雇主的人力资源网站上了解更多信息。',
    buy_up_text: '注册期间确定的保费。',
    waived_coverage_text: '您已选择放弃健康保险。',
    card_header_tooltips: {
      premiums: {
        text: 'This is the total cost, per pay period, of the benefits that you have selected.',
        title: 'Premiums',
      },
      other_benefits: {
        text: "These 'Other Benefits' include additional benefits that your employer offers you, free of charge, plus any additional buy-up options that you have selected.",
        title: 'Other Benefits',
      },
      hra_contributions: {
        text: 'This is the total amount that you have elected to contribute to savings or spending accounts each pay period.',
        title: 'Account Contributions',
      },
      hsa_contributions: {
        text: 'This is the total amount that you have elected to contribute to savings or spending accounts each pay period.',
        title: 'Account Contributions',
      },
      employer_contributions: {
        text: 'This is the total amount that your employer will contribute to savings or spending accounts each pay period.',
        title: 'Employer Contributions',
      },
    },
    std_name: '短期伤残保险',
    ltd_name: '长期伤残保险',
    benefit_contributions: '福利缴费',
  },
};
